// extracted by mini-css-extract-plugin
export var black = "_h-6";
export var brand = "_h-1";
export var ddefault = "_h-0";
export var error = "_h-3";
export var gray = "_h-2";
export var highContrast = "_h-8";
export var outline = "_h-7";
export var success = "_h-5";
export var warning = "_h-4";